// Manages focused-entity state for the BPMN entity focus mode.
// Module-level refs mirror the pattern used by layerVisibility in layer.ts.
import { ref } from "vue";

type EntityRef = { entity_id: string; label: string };

const focusedEntityId = ref<string | null>(null);

const setFocus = (entityId: string): void => {
    focusedEntityId.value = entityId;
};

const clearFocus = (): void => {
    focusedEntityId.value = null;
};

/**
 * Returns the EntityRef on processElement that matches the currently-focused
 * entity, or undefined when no entity is focused or the element doesn't interact.
 */
const taskInteractsWithFocus = (
    processElement: { entity_refs?: EntityRef[] } | undefined
): EntityRef | undefined => {
    if (!focusedEntityId.value || !processElement?.entity_refs) {
        return undefined;
    }
    return processElement.entity_refs.find(
        (r) => r.entity_id === focusedEntityId.value
    );
};

export { focusedEntityId, setFocus, clearFocus, taskInteractsWithFocus };
